import React from "react";
import {
  ThemeButtonBGPrimary,
  ThemeColor,
  ALERT_TIMEOUT,
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH,
  AUTHENTICATION_URL,
} from "../Config";
import { Link } from "react-router";
import { useState, useEffect } from "react";
import { isValidEmail } from "../Utils";

const SignUpContent = () => {
  //submit form button clicked state
  const [submitClicked, setSubmitClicked] = useState(false);

  //signup values
  const [signUpFieldValues, setSignUpFieldValues] = useState({
    email_address_signup: "",
    password_signup: "",
    confirm_password_signup: "",
  });

  //alert state
  const [alert, setAlert] = useState({
    type: "success",
    message: "",
    visible: false,
  });

  //use effect handle submit action
  //use effect to handle the submit button click
  useEffect(() => {
    // If the submit button was clicked
    if (submitClicked === true) {
      //call endpoint
      signUpFormRequest();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClicked]);

  //signup from endpoint
  const signUpFormRequest = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(AUTHENTICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "SIGNUP",
        email_address_signup: signUpFieldValues.email_address_signup,
        password_signup: signUpFieldValues.password_signup,
        confirm_password_signup: signUpFieldValues.confirm_password_signup,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //scroll to top
        window.scrollTo(0, 0);
        //check success
        if (data.success === true) {
          //set alert state to show error
          setAlert({
            type: "success",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);

          //reset output
          setSignUpFieldValues({
            ...signUpFieldValues,
            email_address_signup: "",
            password_signup: "",
            confirm_password_signup: "",
          });
        } else {
          //set alert state to show error
          setAlert({
            type: "danger",
            message: data.message,
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }
        //hide the spinner
        setSubmitClicked(false);
        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //set alert state to show error
        setAlert({
          type: "danger",
          message: "Sorry. Something went wrong. Please try again later.",
          visible: true,
        });
        //hide alert after 5 seconds
        setTimeout(() => {
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);
        //hide the spinner
        setSubmitClicked(false);
      });
  };

  //submit handler for the form
  const onSubmitSignUpForm = (event) => {
    // Get the textarea value
    event.preventDefault();

    //check if mail id valid
    //if not valid return and show error
    if (isValidEmail(signUpFieldValues.email_address_signup) === false) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: `Entered email address ${signUpFieldValues.email_address_signup} is not valid. Please enter a valid email addess.`,
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //check password character count
    if (
      signUpFieldValues.password_signup.length < PASSWORD_MIN_LENGTH ||
      signUpFieldValues.password_signup.length > PASSWORD_MAX_LENGTH
    ) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: `Password length must be of ${PASSWORD_MIN_LENGTH}-${PASSWORD_MAX_LENGTH} characters`,
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //check password and confirm password
    if (
      signUpFieldValues.password_signup !==
      signUpFieldValues.confirm_password_signup
    ) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: `Passwords mismatch`,
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitClicked(true);
  };

  //onvalue change handler for the inputs
  const onChangeSignUpForm = (event) => {
    // Update the state with the new value
    setSignUpFieldValues({
      ...signUpFieldValues,
      [event.target.id]: event.target.value,
    });
  };

  return (
    <div className="p-3">
      <div
        className="container col-md-4 col-md-offset-4"
        style={{ marginTop: "6rem" }}
      >
        {/* Alert for failure */}
        <div
          className={`alert alert-${alert.type} ${
            alert.visible ? "" : "d-none"
          } fade show`}
          role="alert"
          style={{ marginTop: "5rem" }}
        >
          {alert.message}
        </div>

        {/* title */}
        <h1 className="display-6 text-center mt-2">Sign Up</h1>

        {/* Form */}
        <div className="justify-content-center" style={{ width: "100%" }}>
          <form className="mt-5" onSubmit={onSubmitSignUpForm}>
            <div className="form-group">
              <label className="text-muted me" htmlFor="email_address_signup">
                Email Address
              </label>
              <div className="mt-1">
                <input
                  type="email"
                  className="form-control"
                  id="email_address_signup"
                  placeholder="Email Address"
                  style={{ borderColor: ThemeColor, height: "50px" }}
                  onChange={onChangeSignUpForm}
                  value={signUpFieldValues.email_address_signup}
                />
              </div>
            </div>
            <div className="form-group mt-3">
              <label className="text-muted" htmlFor="password_signup">
                Password ({PASSWORD_MIN_LENGTH} - {PASSWORD_MAX_LENGTH}{" "}
                characters)
              </label>
              <div className="mt-1">
                <input
                  type="password"
                  className="form-control"
                  id="password_signup"
                  placeholder="Password"
                  style={{ borderColor: ThemeColor, height: "50px" }}
                  onChange={onChangeSignUpForm}
                  value={signUpFieldValues.password_signup}
                />
              </div>
            </div>
            <div className="form-group mt-3">
              <label className="text-muted" htmlFor="confirm_password_signup">
                Confirm Password
              </label>
              <div className="mt-1">
                <input
                  type="password"
                  className="form-control"
                  id="confirm_password_signup"
                  placeholder="Confirm Password"
                  style={{ borderColor: ThemeColor, height: "50px" }}
                  onChange={onChangeSignUpForm}
                  value={signUpFieldValues.confirm_password_signup}
                />
              </div>
            </div>

            {/* Signup button */}
            <div className="text-center mt-5 justify-content-center d-flex">
              <div
                className={`spinner-border text-dark me-3 align-self-center ${
                  submitClicked ? "" : "d-none"
                }`}
                role="status"
                style={{
                  width: "32.6px",
                  height: "30px",
                }}
              >
                <span className="sr-only"></span>
              </div>
              <button
                type="submit"
                className="btn btn-primary fs-3 px-5"
                style={{
                  backgroundColor: ThemeButtonBGPrimary,
                  width: "100%",
                  height: "60px",
                }}
                onClick={(e) => {
                  //blur
                  e.currentTarget.blur();
                }}
              >
                Sign Up
              </button>
            </div>
          </form>
        </div>

        {/* Signup using */}
        <div
          className="justify-content-center text-center"
          style={{ marginTop: "4rem" }}
        >
          <p className="text-muted fs-5 lead">
            already have an account?{" "}
            <Link to="/login" className="text-decoration-none">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUpContent;
